import React from "react";
import { useScreenSize } from "../../../utils/media-query";
import Toolbar, { Item } from "devextreme-react/toolbar";
import DataGrid, { Column, Paging, Pager } from "devextreme-react/data-grid";
import "./style.scss";
import { formatMessage } from "devextreme/localization";

export default function DataGridApproval({ dataTable }) {
  const { isXSmall } = useScreenSize();
  return (
    <div>
      <Toolbar className="mt-4 mb-1">
        <Item location="before">
          <div className="fw-bold text-uppercase">
            {formatMessage("LeaveSummary")}
          </div>
        </Item>
      </Toolbar>
      <DataGrid
        showBorders={true}
        showRowLines={true}
        hoverStateEnabled={true}
        rowAlternationEnabled={true}
        columnAutoWidth={true}
        columnHidingEnabled={true}
        // columnResizingMode="widget"
        allowColumnResizing={true}
        alignment="center"
        dataSource={dataTable}
        className="datagrid-has-toolbar-actions"
      >
        <Paging defaultPageSize={2} />
        <Pager
          showPageSizeSelector={true}
          allowedPageSizes={[5, 10, 20]}
          showInfo={true}
        />
        <Column
          caption={formatMessage("Year")}
          dataField="Year"
        />
        <Column
          caption={formatMessage("Total")}
          dataField="TotalLeaveYear"
        />
        <Column
          caption={formatMessage("TotalLeavePeriod")}
          dataField="TotalLeavePeriod"
        />
        <Column
          caption={formatMessage("Used")}
          dataField="LeavePesonalUsed"
        />
        <Column
          caption={formatMessage("LeaveRemain")}
          dataField="LeaveRemain"
        />
        <Column
          caption={formatMessage("Jan")}
          dataField="T1"
        />
        <Column
          caption={formatMessage("Feb")}
          dataField="T2"
        />
        <Column
          caption={formatMessage("Mar")}
          dataField="T3"
        />
        <Column
          caption={formatMessage("Apr")}
          dataField="T4"
        />
        <Column
          caption={formatMessage("May")}
          dataField="T5"
        />
        <Column
          caption={formatMessage("Jun")}
          dataField="T6"
        />
        <Column
          caption={formatMessage("Jul")}
          dataField="T7"
        />
        <Column
          caption={formatMessage("Aug")}
          dataField="T8"
        />
        <Column
          caption={formatMessage("Sep")}
          dataField="T9"
        />
        <Column
          caption={formatMessage("Oct")}
          dataField="T10"
        />
        <Column
          caption={formatMessage("Nov")}
          dataField="T11"
        />
        <Column
          caption={formatMessage("Dec")}
          dataField="T12"
        />
      </DataGrid>
    </div>
  );
}
